import React from "react";
import ReactDOM from "react-dom/client";
import "./theme.scss";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "./assets/static/styles/index.scss";
import { configureHotelTraderTelemetry } from "@hoteltradergit/ht-telemetry-ui-lib";

// Telemetry + Heap boot (replaces the old index.html snippet). The lib takes
// resolved values only, so per-environment selection lives HERE. The Rapid7
// token comes from VITE_R7INSIGHT_TOKEN, set in `.env` for every deployed
// environment and overridable per app via Amplify console env vars; Heap still
// falls back to an origin check until VITE_HEAP_ENV_ID is configured
// everywhere. An environment with no token resolves to the console sink.
// Runs before render so heap method stubs exist for every component.
const IS_PROD_ORIGIN =
  window.location.origin === "https://supplier.hoteltrader.com";

configureHotelTraderTelemetry({
  app: "supplier_portal",
  heapEnvId:
    import.meta.env.VITE_HEAP_ENV_ID ||
    (IS_PROD_ORIGIN ? "1171089928" : "2426836863"),
  rapid7Token: import.meta.env.VITE_R7INSIGHT_TOKEN,
  // The sink calls R7Insight.init() itself once the CDN script has loaded,
  // buffering anything logged in the meantime. This replaces the inline
  // prod-only init that used to sit in index.html, so the token has a single
  // source (the env var) and non-prod origins can initialise at all.
  rapid7AutoInit: true,
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Core Web Vitals -> Heap. Called bare: reportWebVitals defaults to the Heap
// sink, so there is no callback to forget (which is how this sat inert before).
reportWebVitals();
